import isSmartphone from '../utils/isSmartPhone';

window.snsButtonClick = function(sns) {
  window.gtag("event", window.location.pathname, {
    event_category: `${sns}_share_nav`,
    event_label: isSmartphone() ? "SP" : "PC",
    value: 1,
  });
}
